import { getFooterContent } from '@/services/content.service'
import { FooterLink, FooterLinkBlock } from '@/types'
import { ActionContext as VuexActionContext } from 'vuex'

interface FooterState {
    navigation: FooterLinkBlock[];
    bottomLinks: FooterLink[];
    loading: boolean;
    loaded: boolean;
    exception: boolean;
}

type FooterLinksDto = {
  navigation: FooterLinkBlock[];
  bottomLinks: FooterLink[];
}

export type ActionContext = VuexActionContext<FooterState, {}>

export const NAME_SPACE = 'footerContent'

export enum FooterContentAction {
  Fetch = 'footerContent/fetchContent'
}

export enum FooterContentGetter {
  Navigation = 'footerContent/navigation',
  BottomLinks = 'footerContent/bottomLinks',
  Loaded = 'footerContent/isLoaded',
}

const footerStore = {
  namespaced: true,
  state: {
    navigation: [],
    bottomLinks: [],
    loading: false,
    loaded: false,
    exception: false
  },
  getters: {
    navigation: (state: FooterState) => state.navigation,
    bottomLinks: (state: FooterState) => state.bottomLinks,
    isException: (state: FooterState) => state.exception,
    isLoaded: (state: FooterState) => state.loaded
  },
  mutations: {
    setLoading: (state: FooterState, loading: boolean) => {
      state.loading = loading
    },
    setLoaded: (state: FooterState, loaded: boolean) => {
      state.loaded = loaded
    },
    setException: (state: FooterState, exception: boolean) => {
      state.exception = exception
    },
    setContent: (
      state: FooterState,
      { navigation, bottomLinks }: FooterLinksDto
    ) => {
      state.navigation = navigation
      state.bottomLinks = bottomLinks
    }
  },
  actions: {
    fetchContent: async ({ commit }: ActionContext): Promise<void> => {
      commit('setLoading', true)
      commit('setException', false)

      try {
        const { navigation, bottomLinks } = await getFooterContent()

        commit('setContent', {
          navigation,
          bottomLinks
        })
        commit('setLoaded', true)
      } catch (err) {
        commit('setException', true)
      } finally {
        commit('setLoading', false)
      }
    }
  }
}

export default footerStore
